import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import BuildChildren from 'utils/BuildChildren';
import classes from './CardImageI.module.scss';

const CardImageI = (props) => {
  const {
    heading,
    contentMarkup,
    imageURI,
    contentCards = [],
    color,
  } = props;

  return (
    <div className={classes.container}>
      <div
        className={classes.contentContainer}
        style={{
          backgroundImage: `url(${imageURI})`,
        }}
      >
        {heading &&
          <div
            className={classes.heading}
            dangerouslySetInnerHTML={{ __html: heading }}
          />}
        {contentMarkup &&
          <div
            className={classes.contentMarkup}
            dangerouslySetInnerHTML={{ __html: contentMarkup }}
          />}
        {contentCards.length > 0 &&
          <div className={classes.cards}>
            {contentCards.map((card, i) => (
              <div className={classNames(classes.card, `border-${color}`)} key={i}>
                {BuildChildren(card)}
              </div>
            ))}
          </div>}
      </div>
    </div>
  );
};

CardImageI.propTypes = {
  /**
   * Heading on the card
  */
  heading: PropTypes.string,
  /**
   * Background Color for the Heading
  */
  color: PropTypes.string,
  /**
   * Content of the card
  */
  contentMarkup: PropTypes.string,
  /**
   * Image URL
  */
  imageURI: PropTypes.string,
  contentCards: PropTypes.array,
};

export default CardImageI;
